import portalAxiosInstance from './portalAxiosInstance';

const PortalInvoiceService = {
    getInvoices: () => portalAxiosInstance.get('/api/portal/invoices').then(r => r.data),
    getInvoice: (id) => portalAxiosInstance.get(`/api/portal/invoices/${id}`).then(r => r.data),
    downloadPdf: (id) => portalAxiosInstance.get(`/api/portal/invoices/${id}/pdf`, { responseType: 'blob' }),
    downloadCreditNotePdf: (creditNoteId) => portalAxiosInstance.get(`/api/portal/invoices/credit-notes/${creditNoteId}/pdf`, { responseType: 'blob' }),
};

export default PortalInvoiceService;
